import {
	createRouter,
	createWebHistory,
} from 'vue-router'
import NotFound from '@/NotFound'

export default createRouter({
	history: createWebHistory('/'),
	routes: [
		{
			path: '/',
			name: 'Home',
			redirect: '/command',
		},
		{
			path: '/:pathMatch(.*)*',
			name: 'NotFound',
			component: NotFound,
		}
	],
});
